import {
  GlobalAction,
  GlobalActions,
  GlobalPut,
  ModalType,
  SavedState,
  WrappedSavedStatesLoaded,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '@ps20-frontend/apps/checkout-store';
import { showUnfAngaben } from '../selector/produkt.selector';
import { CheckoutActions } from '../checkout.actions';

export function* watchGesundheitsdatenAfterLoad() {
  yield takeEvery(
    GlobalActions.SAVED_STATES_LOADED,
    safeSaga(checkGesundheitsdaten, App.SHOP_CHECKOUT),
  );
}

export function* checkGesundheitsdaten(action: GlobalAction<WrappedSavedStatesLoaded>) {
  const actionPayload: SavedState = action.payload.savedSensitiveStatesLoaded;
  const state: IAppState = yield select();
  const globalPut = GlobalPut.getInstance();
  if (showUnfAngaben(state)) {
    if (!actionPayload) {
      yield take(GlobalActions.ALL_TARIFIERUNGEN_HAVE_ENDED);
      yield call(
        globalPut.put.bind(globalPut),
        new GlobalActions().requestModal(ModalType.GESUNDHEITSDATEN_DELETED),
      );
    } else if (actionPayload.unfAngaben?.vpAngabenListe?.length > 0) {
      yield put(new CheckoutActions().updateGesundheitsdaten(actionPayload));
    }
  }
}
